import React from 'react';
import type { IProps } from './logo-secondary-container';

const LogoSecondary: React.FC<IProps> = ({ agencyConfig, className = '' }) => {
  if (agencyConfig?.icon) {
    return (
      <div className={`logo--secondary ${className}`}>
        {!!agencyConfig?.icon && <img src={agencyConfig?.icon} alt="Logo" />}
      </div>
    );
  }

  if (agencyConfig?.logo?.secondary !== '') {
    return (
      <div className={`logo--secondary ${className}`}>
        <img src={agencyConfig?.logo?.secondary} alt="Logo" />
      </div>
    );
  }

  return null;
};

export default LogoSecondary;
